import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { AuthenticationService } from './services/authentication.service';
import { tap } from 'rxjs/operators';
import { DraftsPage } from './drafts/drafts.page';

import { EventsConstants } from './utils/EventsConstants';
import { Env } from './utils/env';
import { Events } from './utils/Events';
@Injectable({
  providedIn: 'root'
})

export class RestCallsService {
  apiUrl = 'http://104.199.226.121:8087';
  // apiUrl = 'https://erp.thefitway.io';
  // apiUrl = 'http://localhost:8087';
  apiGetQuotations = this.apiUrl + '/quotation/get';
  apiAddQuotation = this.apiUrl + '/quotation/new';
  apiUpdateQuotation = this.apiUrl + '/quotation/update';
  apiGetOrders = this.apiUrl + '/orders/get';
  apiGetCustomers = this.apiUrl + '/customer/get';
  apiGetUsers = this.apiUrl + '/user/get';
  apiGetProducts = this.apiUrl + '/products/get';
  apiAddProduct = this.apiUrl + '/product/new';
  apiGetUserCompanies = this.apiUrl + '/company/getUserCompany';
  apiDeleteCustomer = this.apiUrl + '/customer/deleteCustomer';
  apiAddCustomer = this.apiUrl + '/customer/new';
  apiDashboardGetQuotations = this.apiUrl + '/dashboard/quotations';
  apiDashboardGetOrders = this.apiUrl + '/dashboard/order';
  apiDeleteQuotation = this.apiUrl + '/quotation/delete';

  apiUpdateCustomer = this.apiUrl + `/customer/update`;
  apiAddCompany = this.apiUrl + `/company/new`;
  apiUpdateCompany = this.apiUrl + `/company/update`;
  apiAddUser = this.apiUrl + `/user/new`;
  apiSendPdf = this.apiUrl + `/quotation/sendPdf`;
  apiAddContactForUser = this.apiUrl + `/customer/newCustomerContact`;
  apiUpdateContactForUser = this.apiUrl + `/customer/updateCustomerContact`;
  apiGetContactForUser = this.apiUrl + `/customer/getCustomerContacts`;
  apiDeleteContactForUser = this.apiUrl + `/customer/deleteCustomerContacts`;

  apiDeleteUser = this.apiUrl + '/user/delete';
  apiGetUser = this.apiUrl + '/user/getUserInfo';
  apiUpdateUser = this.apiUrl + '/user/update';
  apiAddParentToUser = this.apiUrl + '/user/insertParent';
  apiDeleteParentOfUser = this.apiUrl + '/user/deleteParent';
  apiGetTerms = this.apiUrl + '/quotation/getTerms';
  apiAddTerm = this.apiUrl + '/quotation/insertTerms';
  apiDeleteTerm = this.apiUrl + '/quotation/deleteTerms';
  apiGetProductCategory = this.apiUrl + '/product/getUniqueCategory';
  apiGetQuatDetails = this.apiUrl + '/quotation/getAllQuoteDetails';
  apiGetQuotationHtml = this.apiUrl + '/quotation/getExcel';

  apiAddPerformaInvoice = this.apiUrl + '/performaInvoice/new';
  apiGetPerformaInvoice = this.apiUrl + '/performaInvoice/get';
  apiDeletePerformaInvoice = this.apiUrl + '/performaInvoice/delete';

  apiAddDevice = this.apiUrl + '/deviceId/insertOrUpdate';
  apiRemoveDevice = this.apiUrl + '/deviceId/delete';

  apiDeleteProduct = this.apiUrl + '/product/delete';
  apiUpdateProduct = this.apiUrl + '/product/update';
  // apiGetReport = this.apiUrl + '/quotation/report';
  apiGetReportTypes = this.apiUrl + '/report/getTypes';
  apiGetReport = this.apiUrl + '/report/getReport';

  apiAddRecord = this.apiUrl + '/records/new';
  apiGetRecords = this.apiUrl + '/records/get';
  apiDeleteRecord = this.apiUrl + '/records/delete';

  public isWeb = true;

  childs = [];
  typeOfInvoice: any;
  typeOfCustomer = 1;
  drafts: any;
  productsAll = [
    {
      title: 'Treadmill', products: [],
      subCatogories: []
    },
    {
      title: 'Elliptical', products: [],
      subCatogories: []
    },
    {
      title: 'Exercise Bike', products: [],
      subCatogories: []
    },
    {
      title: 'Rower', products: [],
      subCatogories: []
    },
    {
      title: 'Multi Gym', products: [],
      subCatogories: []
    },
    {
      title: 'Single Station', products: [],
      subCatogories: []
    },
    {
      title: 'Spin Bike', products: [],
      subCatogories: []
    },
    {
      title: 'Dual Station', products: [],
      subCatogories: []
    },
    {
      title: 'Accessories', products: [],
      subCatogories: []
    },
    {
      title: 'Home Gym', products: [],
      subCatogories: []
    },
    {
      title: 'Benches', products: [],
      subCatogories: []
    },
    {
      title: 'Massager', products: [],
      subCatogories: []
    },
    {
      title: 'Weights', products: [],
      subCatogories: []
    },
    {
      title: 'Rods', products: [],
      subCatogories: []
    },
    {
      title: 'Sports', products: [],
      subCatogories: []
    },
  ];

  user: any;
  products = [];
  filteredProducts = [];
  constructor(private http: HttpClient,
    public storage: Storage,
    public events: Events,
    public auth: AuthenticationService) {
    this.storage.get('products').then((val) => {
      this.products = JSON.parse(val);
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.productsAll.length; i++) {
        this.getFilterProducts(this.productsAll[i].title).then(productsSearch => {
          this.productsAll[i].products = productsSearch;
        });
      }
    });
    this.storage.get('drafts').then((val) => {
      if (val === null || val === undefined) {
        this.drafts = [];
      } else {
        this.drafts = JSON.parse(val);
      }
      if (Env.DEBUG) {
        console.log(this.drafts);
      }
    });
  }

  login(data) {
    return this.http.post(this.apiUrl + '/user/login', data)
      .pipe(
        tap((_res: any) => {
          this.user = _res.data;
        }),
        // catchError(this.handleError('addHero', hero))
      );
  }

  setLoggedIn(user: any) {
    this.user = user;
  }

  loggedOut() {
    this.user = null;
  }
  
  getQuotations(data, addChilds) {
    // //console.log(`getQuotations : ` + data);
    if (addChilds && this.childs !== undefined && this.childs !== null) {
      this.childs.forEach(c => {
        data.userId += ',' + c;
      });
    }
    // console.log(data);
    return this.http.post(this.apiGetQuotations, data);
  }
  getQuotationDetails(data) {
    return this.http.post(this.apiGetQuatDetails, data);
  }
  getQuotationHtml(data) {
    return this.http.post(this.apiGetQuotationHtml, data);
  }
  addCustomerContact(data) {
    return this.http.post(this.apiAddContactForUser, data);
  }
  getCustomerContacts(data) {
    return this.http.post(this.apiGetContactForUser, data);
  }
  deleteCustomerContact(data) {
    return this.http.post(this.apiDeleteContactForUser, data);
  }
  updateCustomerContact(data) {
    return this.http.post(this.apiUpdateContactForUser, data);
  }
  addUser(data) {
    return this.http.post(this.apiAddUser, data);
  }
  getUsers(data) {
    return this.http.post(this.apiGetUsers, data);
  }
  addParentToUser(data) {
    return this.http.post(this.apiAddParentToUser, data);
  }
  deleteParentOfUser(data) {
    return this.http.post(this.apiDeleteParentOfUser, data);
  }
  newQuotation(data) {
    return this.http.post(this.apiAddQuotation, data);
  }
  deleteQuotation(data) {
    return this.http.post(this.apiDeleteQuotation, data);
  }
  deleteProduct(data) {
    return this.http.post(this.apiDeleteProduct, data);
  }
  updateProduct(data) {
    return this.http.post(this.apiUpdateProduct, data);
  }
  getReport(data) {
    return this.http.post(this.apiGetReport, data);
  }
  getReportTypes(data) {
    return this.http.post(this.apiGetReportTypes, data);
  }
  updateQuotation(data) {
    return this.http.post(this.apiUpdateQuotation, data);
  }
  getCompanies(data) {
    return this.http.post(this.apiGetUserCompanies, data);
  }
  getDashboardQuotations(data) {
    // console.log(data);
    return this.http.post(this.apiDashboardGetQuotations, data);
  }
  newPerformaInvoice(data) {
    return this.http.post(this.apiAddPerformaInvoice, data);
  }
  deletePerformaInvoice(data) {
    return this.http.post(this.apiDeletePerformaInvoice, data);
  }
  getPerformaInvoice(data, addChilds) {
    if (addChilds && this.childs !== undefined && this.childs !== null) {
      this.childs.forEach(c => {
        data.userId += ',' + c;
      });
    }
    return this.http.post(this.apiGetPerformaInvoice, data);
  }
  getDashboardOrders(data) {
    return this.http.post(this.apiDashboardGetOrders, data);
  }

  getTerms(data) {
    return this.http.post(this.apiGetTerms, data);
  }
  addTerm(data) {
    return this.http.post(this.apiAddTerm, data);
  }
  deleteTerm(data) {
    return this.http.post(this.apiDeleteTerm, data);
  }


  getRecord(data) {
    return this.http.post(this.apiGetRecords, data);
  }
  addRecord(data) {
    return this.http.post(this.apiAddRecord, data);
  }
  deleteRecord(data) {
    return this.http.post(this.apiDeleteRecord, data);
  }

  apiResponse: any;
  getUniqueProducts(data) {
    console.log("param")
    console.log(data)
    

    this.http.post(this.apiGetProductCategory, data).subscribe((res: any) => {
      console.log("refresh call finish")
      if (res.success) {
        this.productsAll = [];
        this.apiResponse = res.data;
        for (let i = 0; i < res.data.length; i++) {
          this.productsAll.push(
            {
              title: res.data[i].category, products: [],
              subCatogories: res.data[i].series_name
            });
        }
        console.log("refresh call finish")
        this.downloadAndStoreProducts(data);
        if (Env.DEBUG) { console.log(res); }
      }
    });
  }
  sendPdf(id) {
    // console.log(this.apiSendPdf + '?quotId=' + id);
    const data = {
      quotId: id
    };
    return this.http.post(this.apiSendPdf, data);
  }

  // {
  //   "userId":1,
  //   "customerId":1,
  //   "productId":1,
  //   "purchaseDate":1556812281000,
  //   "lastId":2,
  //   "enquirySource":2,
  //   "isDetailRequired":true
  // }
  getOrders(data) {
    return this.http.post(this.apiGetOrders, data);
  }

  addCustomer(data) {
    return this.http.post(this.apiAddCustomer, data);
  }
  addCompany(data) {
    return this.http.post(this.apiAddCompany, data);
  }
  updateCompany(data) {
    return this.http.post(this.apiUpdateCompany, data);
  }
  getCustomers(data) {
    return this.http.post(this.apiGetCustomers, data);
  }
  deleteCustomer(data) {
    return this.http.post(this.apiDeleteCustomer, data);
  }
  deleteUser(data) {
    return this.http.post(this.apiDeleteUser, data);
  }
  getUserInfo(data) {
    return this.http.post(this.apiGetUser, data);
  }
  updateUser(data) {
    return this.http.post(this.apiUpdateUser, data);
  }
  updateCustomer(data) {
    return this.http.post(this.apiUpdateCustomer, data);
  }
  getProducts(data) {
    return this.http.post(this.apiGetProducts, data);
  }

  addProduct(data) {
    return this.http.post(this.apiAddProduct, data);
  }

  addDeviceNotification(data) {
    if (Env.DEBUG) { console.log(data); }
    // {
    //   appName: 'ERP', userId: 1, deviceId: 1
    // }
    return this.http.post(this.apiAddDevice, data);
  }
  removeDeviceNotification(data) {
    if (Env.DEBUG) { console.log(data); }
    return this.http.post(this.apiRemoveDevice, data);
  }
  async getProductsPage(pageId) {
    const pageSize = 10;
    const start = pageId * pageSize;
    if (start >= this.products.length) {
      return null;
    }
    let end = start + pageSize;
    if (end > this.products.length) {
      end = this.products.length - 1;
    }
    return await this.products.slice(start, end);
  }

  resetProducts() {
    for (let i = 0; i < this.productsAll.length; i++) {
      for (let j = 0; j < this.productsAll[i].products.length; j++) {
        this.productsAll[i].products[j].discount = 0;
        this.productsAll[i].products[j].selected = false;
        this.productsAll[i].products[j].gstIncluded = false;
        this.productsAll[i].products[j].showMrp = true;
        this.productsAll[i].products[j].hidePrice = false;
        this.productsAll[i].products[j].quantity = 1;
      }
    }
  }

   downloadAndStoreProducts(data) {
    console.log("refresh call storing")

    this.getProducts(data).subscribe((res: any) => {
      this.products = [];
      if (Env.DEBUG) { console.log(res); }
      this.storage.set(`products`, JSON.stringify(this.products));
      if (res.data !== null) {
        for (let i = 0; i < res.data.length; i++) {
          this.products.push({
            id: res.data[i].id,
            company_id: res.data[i].company_id,
            asin: res.data[i].asin,
            name: res.data[i].name,
            model_id: res.data[i].model_id,
            brand:res.data[i].brand,
            endSeriesIndex: i,
            category: res.data[i].category,
            type: res.data[i].type,
            series_name: res.data[i].series_name,
            mrp: res.data[i].mrp,
            dealer_price: res.data[i].dealer_price,
            dealer_price1: res.data[i].dealer_price1,
            dealer_price2: res.data[i].dealer_price2,
            dealer_price3: res.data[i].dealer_price3,
            unit: res.data[i].unit,
            tax: res.data[i].tax,
            desc: res.data[i].desc,
            images: res.data[i].images,
            specification: res.data[i].specification,
            brochure_url: res.data[i].brochure_url,
            is_active: res.data[i].is_active,
            created: res.data[i].created,
            updated: res.data[i].updated,
            hidePrice: false,
            quantity: 1,
            discount: 0,
            selected: false,
            gstIncluded: false,
            customerPrice: res.data[i].mrp,
            showMrp: true,
            showSeriesName: false,
            hidden: false,
          });
        }
      }
      this.storage.set(`products`, JSON.stringify(this.products));
      for (let i = 0; i < this.productsAll.length; i++) {
        this.getFilterProducts(this.productsAll[i].title).then(productsSearch => {
          console.log(productsSearch);
          this.productsAll[i].products = productsSearch;
          let lastSeriesId = 0;
          for (let j = 0; j < this.productsAll[i].products.length; j++) {
            let showSeriesName = false;
            if (j === 0) {
              showSeriesName = true;
            } else {
              if (this.productsAll[i].products[j - 1].series_name !== this.productsAll[i].products[j].series_name) {
                showSeriesName = true;
                this.productsAll[i].products[lastSeriesId].endSeriesIndex = (j - 1);
                lastSeriesId = j;
                // //console.log('lastId : ' + lastSeriesId);
              } else {
                // //console.log(false);
              }
            }
            this.productsAll[i].products[j].showSeriesName = showSeriesName;
          }
          if (lastSeriesId === 0) {
            if (this.productsAll[i].products.length > 0) {
              this.productsAll[i].products[0].endSeriesIndex = this.products.length - 1;
            }
          }



        });
      }
      console.log("refresh call done")
      this.events.publish(EventsConstants.PRODUCTS_LOADED_EVENT, Date.now());
      if (Env.DEBUG) { console.log(this.productsAll); }
    });
  }
  saveChilds(userId) {
    const formData = {
      userId: userId,
    };
    this.getUsers(formData).subscribe((res: any) => {
      this.childs = [];
      for (let i = 0; i < res.data.length; i++) {
        // const [year, month, dayAndTime] = [...res.data[i].created.split('-')];
        // const [day, time] = [...dayAndTime.split('T')];
        // const monthIndex = month - 1;
        // //console.log(year, monthIndex, day);
        this.childs.push(res.data[i].id);
      }
    });
    // console.log(this.childs);
  }
  getAllProducts() {
    // if (this.apiResponse != undefined) {
    //   this.productsAll = [];
    //   console.log(this.apiResponse)
    //   for (let i = 0; i < this.apiResponse.length; i++) {
    //     this.productsAll.push(
    //       {
    //         title: this.apiResponse.category, products: [],
    //         subCatogories: this.apiResponse[i].series_name
    //       });
    //   }
    // }

    return this.productsAll;
  }

  searchInProducts(search) {
    const searchProducts = [];
    for (let i = 0; i < this.products.length; i++) {
      if (this.products[i].type.includes(search) || this.products[i].name.includes(search) ||
        this.products[i].asin.includes(search) || this.products[i].category.includes(search)) {
        searchProducts.push(this.products[i]);
      }
    }
    return searchProducts;
  }

  async getFilterProducts(filter) {
    const filteredProducts = [];
    // console.table(filter);
    if (this.products !== null && this.products !== undefined) {
      for (let i = 0; i < this.products.length; i++) {
        // if ( (filter.category != null) && (this.products[i].category === filter.category)) {
        //   filteredProducts.push(this.jsonCopy(this.products[i]));
        // }
        // else
        if (this.products[i].type.includes(filter)) {
          // //console.log(filter);
          filteredProducts.push(this.jsonCopy(this.products[i]));
        }
      }
    }
    // //console.log(filteredProducts[0]);

    return await filteredProducts;
  }

  jsonCopy(src) {
    return JSON.parse(JSON.stringify(src));
  }

  getCustomerType(type: String): number {
    // console.log(type);
    switch (type) {
      case 'Store Client':
        return 1;
      case 'Gyms':
        return 2;
      case 'Government':
        return 3;
      case 'Real Estate':
        return 4;
      case 'Corporates':
        return 5;
      case 'Government PSUs':
        return 6;
      case 'Education Institutions':
        return 7;
      case 'Dealer':
        return 8;
    }
  }
  getCustomerTypes() {
    return ['Store Client', 'Gyms', 'Government', 'Real Estate', 'Corporates', 'Government PSUs', 'Education Institutions',"Dealer"];
  }

  getUserTypes() {
    return [
      {
        type: 'Admin', value: 1
      },
      {
        type: 'Distributor', value: 2
      },
      {
        type: 'Dealer', value: 3
      },
      {
        type: 'Sales Head', value: 4
      },
      {
        type: 'Sales Rep', value: 5
      },
    ];
  }

  getCustomerTypeNumber(type: Number): String {
    switch (type) {
      case 1:
        return 'Store Client';
      case 2:
        return 'Gyms';
      case 3:
        return 'Government';
      case 4:
        return 'Real Estate';
      case 5:
        return 'Corporates';
      case 6:
        return 'Government PSUs';
      case 7:
        return 'Education Institutions';
        case 8:
          return 'Dealer';
    }
  }

  saveToDraft(draft) {
    draft.date = Date.now();
    let price = 0;
    for (let i = 0; i < draft.products.length; i++) {
      price += draft.products[i].customerPrice;
    }
    draft.price = price;
    this.storage.get(`drafts`).then((res: any) => {
      if (Env.DEBUG) { console.log(JSON.parse(res)); }
      if (res === null || res === undefined) {
        this.drafts = [];
      } else {
        this.drafts = JSON.parse(res);
      }
      this.drafts.push(draft);
      this.storage.set('drafts', JSON.stringify(this.drafts));
    });
    return this.drafts.length;
  }

  updateDraft(draft, index) {
    draft.date = Date.now();
    let price = 0;
    for (let i = 0; i < draft.products.length; i++) {
      price += draft.products[i].customerPrice;
    }
    draft.price = price;
    this.storage.get(`drafts`).then((res: any) => {
      if (Env.DEBUG) { console.log(JSON.parse(res)); }
      if (res === null || res === undefined) {
        this.drafts = [];
      } else {
        this.drafts = JSON.parse(res);
      }
      this.drafts[index] = draft;
      this.storage.set('drafts', JSON.stringify(this.drafts));
    });
  }

  getDraft(index) {
    if (index < this.drafts.length) {
      return this.drafts[index];
    }
  }
  deleteDraft(index) {
    this.storage.get(`drafts`).then((res: any) => {
      if (Env.DEBUG) { console.log(JSON.parse(res)); }
      if (res === null || res === undefined) {
        this.drafts = [];
      }
      if (index < this.drafts.length) {
        this.drafts.splice(index, 1);
        return this.storage.set('drafts', JSON.stringify(this.drafts));
      }
    });
  }

  // public async saveDraft(settingName){
  //   return await this.storage.get(`setting:${ settingName }`);
  // }
  // public async remove(settingName){
  //   return await this.storage.remove(`setting:${ settingName }`);
  // }

  getReminder(t) {

  }

  setReminder(t) {

  }

  removeReminder(t) {

  }

  requestForLocation: boolean;
  requestedLocationData: any;

}


